import {
  FETCH_PROPOVERVIEWS,
  FETCH_PROPOVERVIEW,
  SEARCH_PROPOVERVIEWS,
  FETCHING_PROPOVERVIEWS,
} from '../actions/types'; 

const INITIAL_STATE = {
  city:'', 
  fetching:true,
  propOverviews: [],
  propOverview: null,
  offset: 0,
  limit: 10
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case FETCH_PROPOVERVIEWS:
      return { ...state, ...action.payload };
    case FETCH_PROPOVERVIEW:
      return { ...state, propOverview: action.payload };
    
    case SEARCH_PROPOVERVIEWS:
      
      return { ...state, ...action.payload };
   
    case FETCHING_PROPOVERVIEWS:
      return { ...state, fetching: action.payload };
    default:
      return state;
  }
};
